import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import config from "../../../../../../server/src/config";

import * as RaceActions from "../../../../actions/race";
import {removeNonDigits} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

const defaultFilter = {
    fromFilter: '',
    toFilter: '299',
}

class GeneralAddresses extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            isClub: true,
        }, defaultFilter);
    }

    fields = [];

    getInputName() {
        return this.state.isClub ? 'forening' : 'sektion';
    }

    getInputLength() {
        return this.state.isClub ? '3' : '2';
    }


    render() {
        return <div className="general-addresses">
            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className={'radio-buttons-container column-gap'}>
                <div className="radio-button-container">
                    <input id="race-type-ddb" type="radio" checked={this.state.isClub} onChange={() => this.setState(Object.assign({isClub: true}, {fromFilter: '', toFilter: '299'}))}/>
                    <label htmlFor="race-type-ddb">Foreninger</label>
                </div>
                <div className="radio-button-container">
                    <input id="race-type-section" type="radio" checked={!this.state.isClub} onChange={() => this.setState(Object.assign({isClub: false}, {fromFilter: '', toFilter: '69'}))}/>
                    <label htmlFor="race-type-section">Sektioner</label>
                </div>
            </div> : null}
            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className={'column-gap'}>
                <div className={'attribute-pair'}>
                    <label>Fra {this.getInputName()}</label>
                    <UserFieldElement
                        dataType={UserFieldDataType.regex}
                        placeholder=""
                        className="field-1 very-small-field"
                        containerClassName="display-inline-block"
                        name="fromFilter"
                        id="fromFilter"
                        maxLength={this.getInputLength()}
                        options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{${this.getInputLength()}}`}]}
                        value={this.state.fromFilter}
                        autoCheckErrors={true}
                        hideErrWhenFocused={true}
                        hideErrUntilFocused={true}
                        onChange={this.onDigitInputFieldChange}
                        onBlur={() => {
                            if(this.state.isClub) {
                                this.fields[0].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.fromFilter)) this.setState({fromFilter: this.state.fromFilter.padStart(3, '0')});
                            }
                        }}
                        ref={instance => { this.fields[0] = instance; }}
                    />
                </div>
                <div className={'attribute-pair'}>
                    <label>Til {this.getInputName()}</label>
                    <UserFieldElement
                        dataType={UserFieldDataType.regex}
                        placeholder=""
                        className="field-1 very-small-field"
                        containerClassName="display-inline-block"
                        name="toFilter"
                        id="toFilter"
                        maxLength={this.getInputLength()}
                        options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: `[0-9]{${this.getInputLength()}}`}]}
                        value={this.state.toFilter}
                        autoCheckErrors={true}
                        hideErrWhenFocused={true}
                        hideErrUntilFocused={true}
                        onChange={this.onDigitInputFieldChange}
                        onBlur={() => {
                            if(this.state.isClub) {
                                this.fields[1].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.toFilter)) this.setState({toFilter: this.state.toFilter.padStart(3, '0')});
                            }
                        }}
                        ref={instance => { this.fields[1] = instance; }}
                    />
                </div>
            </div>}
        </div>
    }

    onDigitInputFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: removeNonDigits(e.target.value)});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        if (this.state.fromFilter !== '' && this.state.toFilter !== '' && this.state.fromFilter > this.state.toFilter) errors.push(`Fra ${this.getInputName()} kan ikke være større end Til ${this.getInputName()}.`);

        const options = {
            isClub:     this.state.isClub ? 1 : 0,
            fromFilter: this.state.fromFilter === '' ? null : this.state.fromFilter,
            toFilter:   this.state.toFilter   === '' ? null : this.state.toFilter,
        }
        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(GeneralAddresses);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/GeneralAddresses.js